import { render, staticRenderFns } from "./BloqueioVitana.vue?vue&type=template&id=81f24466"
import script from "./BloqueioVitana.vue?vue&type=script&lang=js"
export * from "./BloqueioVitana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports